import React from 'react';

import {DialogProps, Grid, Stack} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';
import {FlightLogListCard, OperationListCard} from '@wheeebo/polaris-ui';

import GroupListCard from './member/GroupListCard';
import MemberProfileCard from './member/MemberProfileCard';
import DialogBase from './DialogBase';
import {config} from '@components/Constants';

interface Props extends DialogProps {
  memberId: Types.UUID;
  onGroupSelected: (groupId: Types.UUID) => void;
  onMissionSelected: (missionId: Types.UUID) => void;
  onVehicleSelected: (vehicle: Types.UUID) => void;
  onFlightPathSelected: (missionId: Types.UUID, flightPathId: Types.UUID) => void;
  onClose: () => void;
}

const MemberDialog = ({
  memberId,
  onGroupSelected,
  onMissionSelected,
  onVehicleSelected,
  onFlightPathSelected,
  onClose,
  ...props
}: Props): JSX.Element => {
  return (
    <DialogBase title="Member" onClose={onClose} {...props}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Stack gap={1}>
            <MemberProfileCard memberId={memberId} />
            <OperationListCard
              variant="outlined"
              apiKey={config.GOOGLE_MAP_API_KEY || ''}
              memberId={memberId}
              onMissionSelected={onMissionSelected}
              onVehicleSelected={onVehicleSelected}
              onFlightPathSelected={onFlightPathSelected}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack gap={1}>
            <GroupListCard memberId={memberId} onGroupSelected={onGroupSelected} />
            <FlightLogListCard
              variant="outlined"
              apiKey={config.GOOGLE_MAP_API_KEY || ''}
              memberId={memberId}
              onMissionSelected={onMissionSelected}
              onVehicleSelected={onVehicleSelected}
              onFlightPathSelected={onFlightPathSelected}
            />
          </Stack>
        </Grid>
      </Grid>
    </DialogBase>
  );
};

export default React.memo(MemberDialog);
